var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg048Barrier = function Svg048Barrier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 136,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 136C316 61.557 255.443 0 181 0S46 61.557 46 136s60.557 135 135 135 135-60.557 135-135m-135 45c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45M275.57 271H346V151h-.76c-4.495 49.583-31.009 92.834-69.67 120M376 249.789l90 90v-90l-90-90zM376 354.789l90 90v-62.578l-90-90zM376 512h90v-24.789l-90-90z"
  })));
};
export default Svg048Barrier;